import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, } from 'vue';
import BasePopup from './BasePopup.vue';
import ListBaseInfo from './ListBaseInfo.vue';

interface IPopupProps {
  headers: PartialUnionType;
  others: PartialUnionType;
  book: Book | undefined;
  baseInfo: IPartialUnionBaseInfo;
  nodeType?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    headers: null,
    others: null,
    book: null,
    baseInfo: null,
    nodeType: null
  },
  emits: ['close',],
  setup(__props: any, { emit: emits }) {

/* eslint-disable object-curly-newline, vue/no-setup-props-destructure,no-undef */
const isShowInfoTypeBtn = ref(false);



const handleClose = () => {
  emits('close');
};

const handleChange = (val: string) => {
  // console.log('handleChange: ', val);
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopup, {
    class: "company-list-popup",
    baseInfo: __props.baseInfo,
    "is-show-info-type-btn": isShowInfoTypeBtn.value,
    onClose: handleClose,
    onChange: handleChange
  }, {
    detail: _withCtx(() => [
      _createVNode(ListBaseInfo, {
        headers: __props.headers,
        others: __props.others,
        book: __props.book,
        baseInfo: __props.baseInfo
      }, null, 8, ["headers", "others", "book", "baseInfo"])
    ]),
    content: _withCtx(() => []),
    _: 1
  }, 8, ["baseInfo", "is-show-info-type-btn"]))
}
}

})